// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import Navbar from "../components/common/Navbar";
// import Footer from "../components/common/Footer";
// import { useCart } from "../context/CartContext";
// import styles from "./ProductDetailPage.module.css";

// function ProductDetailPage() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const { addToCart } = useCart();

//   const [product, setProduct] = useState(null);
//   const [quantity, setQuantity] = useState(1);
//   const [selectedOption, setSelectedOption] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     const fetchProduct = async () => {
//       try {
//         const response = await fetch(`/api/cms/products/${id}`);
//         if (!response.ok) throw new Error("Product not found");
//         const data = await response.json();
//         setProduct(data);
//         // Set default option if variations exist
//         if (data.variations && data.variations.length > 0) {
//           setSelectedOption(data.variations[0]);
//         }
//       } catch (err) {
//         console.error(err);
//         navigate("/products");
//       } finally {
//         setIsLoading(false);
//       }
//     };
//     fetchProduct();
//   }, [id, navigate]);

//   const currentPrice = selectedOption
//     ? selectedOption.price
//     : product?.price || 0;
//   const totalPrice = currentPrice * quantity;

//   const handleAddToCart = () => {
//     // 💎 FIX: Separate the Cart ID from the Database ObjectId
//     addToCart({
//       // id remains a string like "ID-500g" to keep cart items unique
//       id: selectedOption
//         ? `${product._id}-${selectedOption.weight}`
//         : product._id,
//       // databaseId provides the clean 24-character hex string for Mongoose validation
//       databaseId: product._id,
//       name: product.name,
//       variant: selectedOption ? selectedOption.weight : null,
//       price: currentPrice,
//       img: product.imageURL,
//       quantity: quantity,
//     });
//     // Redirecting to cart ensures the user sees the added item
//     navigate("/cart");
//   };

//   if (isLoading || !product) return null;

//   return (
//     <div className={styles.detailPage}>
//       <Navbar />
//       <div className={styles.container}>
//         <div className={styles.imageSection}>
//           <img src={product.imageURL} alt={product.name} />
//         </div>

//         <div className={styles.infoSection}>
//           <h1 className={styles.title}>{product.name}</h1>
//           <p className={styles.priceDisplay}>
//             {totalPrice.toLocaleString()} Br
//           </p>

//           <div className={styles.description}>
//             <p>{product.description}</p>
//           </div>

//           {/* Only show Weight Options if they were added in Admin */}
//           {product.variations && product.variations.length > 0 && (
//             <div className={styles.selectorGroup}>
//               <label>Select Weight</label>
//               <div className={styles.weightGrid}>
//                 {product.variations.map((v) => (
//                   <button
//                     key={v.weight}
//                     className={
//                       selectedOption?.weight === v.weight
//                         ? styles.activeWeight
//                         : ""
//                     }
//                     onClick={() => setSelectedOption(v)}
//                   >
//                     {v.weight}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}

//           <div className={styles.selectorGroup}>
//             <label>Quantity</label>
//             <div className={styles.quantityControl}>
//               <button onClick={() => setQuantity(Math.max(1, quantity - 1))}>
//                 -
//               </button>
//               <span>{quantity}</span>
//               <button onClick={() => setQuantity(quantity + 1)}>+</button>
//             </div>
//           </div>

//           <button className={styles.cartActionBtn} onClick={handleAddToCart}>
//             Add to Cart — {totalPrice.toLocaleString()} Br
//           </button>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// }

// export default ProductDetailPage;
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import { useCart } from "../context/CartContext";
import styles from "./ProductDetailPage.module.css";

function ProductDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const [product, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchProduct = async () => {
      try {
        const response = await fetch(`/api/cms/products/${id}`);
        if (!response.ok) throw new Error("Product not found");
        const data = await response.json();
        setProduct(data);
        if (data.variations && data.variations.length > 0) {
          setSelectedOption(data.variations[0]);
        }
      } catch (err) {
        console.error(err);
        navigate("/products");
      } finally {
        setIsLoading(false);
      }
    };
    fetchProduct();
  }, [id, navigate]);

  const currentPrice = selectedOption
    ? parseFloat(selectedOption.price || 0)
    : parseFloat(product?.price || 0);
  const totalPrice = currentPrice * quantity;

  // 💎 SYMBOL FROM BACKEND
  const symbol = product?.currencySymbol || "Br";

  const handleAddToCart = () => {
    addToCart({
      id: selectedOption
        ? `${product._id}-${selectedOption.weight}`
        : product._id,
      databaseId: product._id,
      name: product.name,
      variant: selectedOption ? selectedOption.weight : null,
      price: currentPrice,
      // 💎 PASS CURRENCY DATA
      currencySymbol: product.currencySymbol || "Br",
      currencyCode: product.currencyCode || "ETB",
      img: product.imageURL,
      quantity: quantity,
    });
    navigate("/cart");
  };

  if (isLoading || !product) return null;

  return (
    <div className={styles.detailPage}>
      <Navbar />
      <div className={styles.container}>
        <div className={styles.imageSection}>
          <img src={product.imageURL} alt={product.name} />
        </div>

        <div className={styles.infoSection}>
          <h1 className={styles.title}>{product.name}</h1>
          <p className={styles.priceDisplay}>
            {symbol} {totalPrice.toLocaleString("en-US")}
          </p>

          <div className={styles.description}>
            <p>{product.description}</p>
          </div>

          {product.variations && product.variations.length > 0 && (
            <div className={styles.selectorGroup}>
              <label>Select Weight</label>
              <div className={styles.weightGrid}>
                {product.variations.map((v) => (
                  <button
                    key={v.weight}
                    className={
                      selectedOption?.weight === v.weight
                        ? styles.activeWeight
                        : ""
                    }
                    onClick={() => setSelectedOption(v)}
                  >
                    {v.weight}
                  </button>
                ))}
              </div>
            </div>
          )}

          <div className={styles.selectorGroup}>
            <label>Quantity</label>
            <div className={styles.quantityControl}>
              <button onClick={() => setQuantity(Math.max(1, quantity - 1))}>
                -
              </button>
              <span>{quantity}</span>
              <button onClick={() => setQuantity(quantity + 1)}>+</button>
            </div>
          </div>

          <button className={styles.cartActionBtn} onClick={handleAddToCart}>
            Add to Cart — {symbol} {totalPrice.toLocaleString("en-US")}
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ProductDetailPage;